import t from "@ext/localization/locale/translate";
import { wrapInGallery } from "@ext/markdown/elements/gallery/edit/logic/addToGallery";
import type { Editor } from "@tiptap/core";
import { GlassToolbarButton, GlassToolbarIcon } from "@ui-kit/GlassToolbar";

interface WrapInGalleryButtonProps {
	editor: Editor;
	getPos: () => number;
}

const WrapInGalleryButton = ({ editor, getPos }: WrapInGalleryButtonProps) => {
	const label = t("editor.gallery.wrap");
	const isInGallery = editor.state.doc.resolve(getPos()).parent.type.name === "gallery";
	if (!editor.schema.nodes.gallery || isInGallery) return null;

	const wrap = () => {
		if (!editor || editor.isDestroyed) return;
		editor.view.dispatch(wrapInGallery(editor.state.tr, getPos()));
	};

	return (
		<GlassToolbarButton aria-label={label} onClick={wrap} tooltipText={label}>
			<GlassToolbarIcon icon="images" />
		</GlassToolbarButton>
	);
};

export default WrapInGalleryButton;
